import React from 'react';
import { useTranslation } from 'react-i18next';
import './MapLoadingScreen.scss';

const MapLoadingScreen = () => {
  const { t } = useTranslation();
  
  return (
    <div className="map-loading-screen">
      <div className="map-loading-screen__navbar-skeleton">
        <div className="map-loading-screen__navbar-skeleton__logo"></div>
        <div className="map-loading-screen__navbar-skeleton__controls">
          <div className="map-loading-screen__navbar-skeleton__control"></div>
          <div className="map-loading-screen__navbar-skeleton__control"></div>
          <div className="map-loading-screen__navbar-skeleton__control"></div>
        </div>
      </div>
      
      <div className="map-loading-screen__content">
        <div className="map-loading-screen__content__search-skeleton"></div>
        
        <div className="map-loading-screen__content__center">
          <div className="map-loading-screen__content__center__icon">
            <img src="/assets/jaakko_head.png" alt="Jaakko" className="map-loading-screen__content__center__icon__image" />
          </div>
          <div className="map-loading-screen__content__center__text">
            {t('common.findingLocation')}
          </div>
          <div className="map-loading-screen__content__center__spinner">
            <div className="map-loading-screen__content__center__spinner__dot"></div>
            <div className="map-loading-screen__content__center__spinner__dot"></div>
            <div className="map-loading-screen__content__center__spinner__dot"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapLoadingScreen; 